var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../node-libs-browser/node_modules/isarray/index.js
// module id = 233
// module chunks = 0 2